import { core } from 'types';
import ClowncarAppConstants from 'constants/ClowncarAppConstants';
import protos from 'utils/protos';

const { MetroArea } = protos;

export function fetchAll(): ApiAction {
  return {
    TockApi: {
      getListProto: '/metroarea',
      type: ClowncarAppConstants.METRO_AREA_GET_ALL,
    },
  };
}

export function update(metroArea: core.IMetroArea): ApiAction {
  const request = MetroArea.fromObject(metroArea);
  return {
    TockApi: {
      putProto: '/metroarea',
      type: ClowncarAppConstants.METRO_AREA_UPDATE,
      request,
    },
  };
}

export function insert(metroArea: core.IMetroArea): ApiAction {
  const request = MetroArea.fromObject(metroArea);
  return {
    TockApi: {
      postProto: '/metroarea',
      type: ClowncarAppConstants.METRO_AREA_INSERT,
      request,
    },
  };
}

export function uploadImage(metroAreaId: number, image: File): ApiAction {
  return {
    TockApi: {
      postFile: `/metroarea/${metroAreaId}/image`,
      request: image,
      type: ClowncarAppConstants.METRO_AREA_UPDATE_IMAGE,
    },
  };
}

export function selectMetroArea(metroArea: core.MetroArea): BaseTockAction {
  return {
    payload: metroArea,
    type: ClowncarAppConstants.METRO_AREA_SELECT,
  };
}
